export const STARTED_BOOKING_DATA_KEY = 'startedBookingData';
